import { Service, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

import { AppConfig } from '../config/app.config';

@Service()
export class SnackBarService {
  private snackBar = inject(MatSnackBar);

  duration = AppConfig.snackBarDuration;
  // TODO: define custom type 'top';
  verticalPosition = AppConfig.snackBarVerticalPosition;

  showSnackbar(msg: string, className?: string, action?: string) {
    const config: MatSnackBarConfig = new MatSnackBarConfig();
    config.duration = this.duration;
    config.verticalPosition = 'top';
    if (className) {
      config.panelClass = className;
    } else {
      config.panelClass = 'snackbar-default';
    }
    this.snackBar.open(msg, action, config);
    return;
  }

  /** Afiseaza eroarea unei cereri HTTP. Alte erori (ex. cererile oprite la logout) sunt ignorate. */
  showError(error: unknown) {
    if (error instanceof HttpErrorResponse) {
      this.showSnackbar(mesajEroare(error), 'snackbar-alert');
    }
  }
}

// Mesajul pentru o eroare HTTP. API-ul trimite textul in `detail` (FastAPI; o lista la erorile
// de validare), iar unele rute vechi in `msg` sau `message`.
export function mesajEroare(error: HttpErrorResponse): string {
  if (error.error instanceof ErrorEvent) {
    return 'Eroare Client: ' + error.error.message;
  }
  const corp = (error.error && typeof error.error === 'object' ? error.error : {}) as {
    detail?: unknown; msg?: unknown; message?: unknown;
  };
  if (Array.isArray(corp.detail)) {
    return (corp.detail as { loc?: unknown; msg?: string }[])
      .map(item => `${item.loc}: ${item.msg}`)
      .join('; ');
  }
  const text = [corp.detail, corp.msg, corp.message].find(valoare => typeof valoare === 'string' && valoare);
  return `Eroare Server : ${error.status}, ` + (text ?? error.message);
}
